<template>
  <v-container id="bid-summary" data-cy="bid-summary" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <idc-component-bid-summary :type="status" :statuses="bidStatuses" :slug="slug" :title="title" :can-submit-bid="canSubmitBid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { ManagementStatus, Status } from '@/utilities/bid/enums/Status'

  export default Vue.extend({
    name: 'DashboardInactiveBidSummary',
    components: {
      IdcComponentBidSummary: () => import('@/components/idc/bids/Summary.vue'),
    },
    props: {
      canSubmitBid: {
        type: Boolean,
        default: () => false,
      },
      bidStatuses: {
        type: Array,
        default: () => [Status.STATUS_TYPE_BID_DECISION_NO_BID, Status.STATUS_TYPE_LOST],
      },
      slug: {
        type: String,
        default: () => 'bid-summary-inactive',
      },
    },
    data: () => ({
      status: ManagementStatus.STATUS_TYPE_BID,
      title: 'No Bid Summary',
    }),
  })
</script>

<style lang="sass">
  section#bid-summary
    .v-card--material
      &__heading.success
        background-color: $dark-red-colour !important
        border-color: $dark-red-colour !important
</style>
